import ErrorMessage from 'components/common/ErrorMessage';
import { useState } from 'react';
import toast from 'react-hot-toast';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { Spinner } from 'reactstrap';
import { setError } from 'slices/userSlice';
import { userSelector } from 'slices/userSlice';
import { userSlice } from 'slices/userSlice';
import { register } from 'slices/userSlice';

function Register() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [formValues, setFormValues] = useState({
        name: '',
        last_name: '',
        email: '',
        password: '',
        password_confirmation: ''
    })
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [confirmPasswordError, setConfirmPasswordError] = useState("");
    const { error, loader } = useSelector(userSelector)

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    const toggleConfirmPasswordVisibility = () => {
        setShowConfirmPassword(!showConfirmPassword);
    };

    const handleChange = (e) => {
        // Handle form submission
        setFormValues({ ...formValues, [e.target.name]: e.target.value });

    }
    const submitCallback = (status) => {
        if (status) {
            toast.success('Successfully registered')
            navigate('/admin', {replace: true});
        }
        else {
            toast.error(error.message);
        }
    };

    const resetAllErrors = () => {
        dispatch(setError({}))
        setConfirmPasswordError("")
    }


    const handleSubmit = (event) => {
        // Handle form submission
        // You can add your own form validation and submission logic here
        event.preventDefault();
        resetAllErrors()
        if (formValues.password != formValues.password_confirmation) {
            setConfirmPasswordError("Passwords do not match!")
            return;
        }
        dispatch(register(formValues, submitCallback))
    }


    return (
        <>
            <section className="auth_section">
                <div className='card_form_wrapper'>
                    <div className='auth_heading'>
                        <img src="/images/logo-fill.png" alt="" />
                        <h1>Create Account</h1>
                        <p>Please enter your detail for Sign up</p>
                    </div>

                    <form className='auth_form' onSubmit={handleSubmit}>
                        <div className='row_inptt'>
                            <div className="form-group">
                                <div className="row-input">
                                    <input
                                        type="text"
                                        name="name"
                                        autoComplete="off"
                                        onChange={handleChange}
                                        placeholder="First name"
                                        required
                                    />
                                </div>
                            </div>

                            <div className="form-group">
                                <div className="row-input">
                                    <input
                                        type="text"
                                        name="last_name"
                                        autoComplete="off"
                                        onChange={handleChange}
                                        placeholder="Last name"
                                        required

                                    />
                                </div>
                            </div>
                        </div>
                        <div className="form-group">
                            <div className="row-input">
                                <img src="/images/mail.png" alt="" />
                                <input
                                    type="email"
                                    name="email" id="email"
                                    autoComplete="off"
                                    onChange={handleChange}
                                    placeholder="Enter your email"
                                    required
                                    pattern='/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/'
                                />
                            </div>
                            {
                                error?.errors?.email?.map((error) => (
                                    <ErrorMessage text={error} />
                                ))
                            }
                        </div>
                        <div className="form-group">
                            <div className="row-input">
                                <img src="/images/lock.png" alt="" />
                                <input
                                    type={showPassword ? "text" : "password"}
                                    name="password" id="password"
                                    autoComplete="off"
                                    onChange={handleChange}
                                    placeholder="Enter your password"
                                    required
                                />
                                <img
                                    src={showPassword ? "/images/eye-close.png" : "/images/eye.png"}
                                    alt=""
                                    onClick={togglePasswordVisibility}
                                    style={{ cursor: 'pointer' }}
                                />
                            </div>
                        </div>
                        <div className="form-group">
                            <div className="row-input">
                                <img src="/images/lock.png" alt="" />
                                <input
                                    type={showConfirmPassword ? "text" : "password"}
                                    name="password_confirmation"
                                    id="password_confirmation"
                                    autoComplete="off"
                                    placeholder="Enter Confirm password"
                                    onChange={handleChange}
                                    required
                                />
                                <img
                                    src={showConfirmPassword ? "/images/eye-close.png" : "/images/eye.png"}
                                    alt=""
                                    onClick={toggleConfirmPasswordVisibility}
                                    style={{ cursor: 'pointer' }}
                                />
                            </div>
                            {confirmPasswordError && <div className='error-message'>{confirmPasswordError}</div>}
                        </div>
                        
                <button disabled={loader} type="submit" className={`btn_auth ${loader? "disabled-button" : ""} `}>
                    {loader ?
                        <>
                            <Spinner size="sm">
                                Loading...
                            </Spinner>

                            <span>
                                {' '}Loading
                            </span>
                        </>
                        :
                        <span>
                           Sign up
                        </span>
                    }
                </button>
                    </form>
                    <div className='center_wrapper'>
                        <p className="para3">Already have an account? <Link to="/login">Login</Link></p>
                    </div>
                </div>
            </section>
        </>
    );
}

export default Register;
